export default __webpack_public_path__ + "assets/images/email-wine-club-header.png";